import { useState } from 'react'

import { useParams } from 'react-router'

import { SpaceSettingsModal } from '@tribeplatform/react-components/Space'
import { useSpace } from '@tribeplatform/react-sdk/hooks'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const SpaceSettingsIcon = () => {
  const [open, setOpen] = useState(false)
  const params = useParams<{ id: string }>()
  const { data: space } = useSpace({
    variables: {
      id: params?.id,
    },
  })

  return (
    <>
      <IconButton
        icon={<SvgIcon name="settings" />}
        size="lg"
        variant="tertiaryNeutral"
        onClick={() => setOpen(true)}
      />
      {space && (
        <SpaceSettingsModal
          onClose={() => setOpen(false)}
          open={open}
          space={space}
        />
      )}
    </>
  )
}
